import React from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";

const flowOptions = [
  {
    badge: "Legacy",
    title: "Standard Sprint Engine",
    description: "Access established, traditional board views and performance metrics.",
    route: "/existing-flow",
    tone: "classic"
  },
  {
    badge: "Next-Gen",
    title: "Hyper-Analysis Flow",
    description: "Unlock predictive insights, comprehensive outcome distribution, and instant contribution clarity.",
    route: "/new-flow",
    tone: "modern"
  },
  {
    badge: "Snapshot",
    title: "Project Status Board",
    description: "Open a clean project overview with dates, completion, sprint variance, and defect phase counts.",
    route: "/project-snapshot",
    tone: "snapshot"
  },
  {
    badge: "Utilization",
    title: "Employee Utilization",
    description: "Review employee allocation, utilization bands, and project coverage from a focused resource view.",
    route: "/employee-utilization",
    tone: "utilization"
  }
];

function LandingPage() {
  const navigate = useNavigate();

  return (
    <main className="landing-page">
      <div className="landing-page__veil" />
      <div className="landing-page__halo landing-page__halo--one" />
      <div className="landing-page__halo landing-page__halo--two" />
      <div className="landing-page__grid-plane" />
      <div className="landing-page__beam landing-page__beam--one" />
      <div className="landing-page__beam landing-page__beam--two" />
      <div className="landing-page__beam landing-page__beam--three" />
      <div className="landing-page__node landing-page__node--one" />
      <div className="landing-page__node landing-page__node--two" />
      <div className="landing-page__node landing-page__node--three" />
      <div className="landing-page__block landing-page__block--one" />
      <div className="landing-page__block landing-page__block--two" />
      <div className="landing-page__block landing-page__block--three" />

      <section className="landing-page__shell">
        <section className="landing-panel">
          <div className="landing-panel__frame" />
          <div className="landing-panel__content">
            <p className="landing-panel__eyebrow">Select Your Access Protocol</p>
            <h1>Choose your data velocity.</h1>
            <p className="landing-panel__description">
              Access your core sprint analytics matrix via curated intelligence paths.
            </p>

            <div className="landing-flow-list">
            {flowOptions.map((option) => (
              <button
                key={option.route}
                type="button"
                className={`landing-flow-card landing-flow-card--${option.tone}`}
                onClick={() => navigate(option.route)}
              >
                <div className="landing-flow-card__top">
                  <span className="landing-flow-card__badge">{option.badge}</span>
                  <span className="landing-flow-card__arrow" aria-hidden="true">
                    <svg viewBox="0 0 24 24" role="presentation">
                      <path
                        d="M7 17 17 7M9.5 7H17v7.5"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.8"
                      />
                    </svg>
                  </span>
                </div>
                <div className="landing-flow-card__content">
                  <h3>{option.title}</h3>
                  <p>{option.description}</p>
                </div>
              </button>
            ))}
            </div>
          </div>
        </section>
      </section>
    </main>
  );
}

export default LandingPage;
